export default "__VITE_ASSET__19209213__"